import { cn } from '@workspace/utils';
import { RenderedContent } from '@workspace/core-ts/utils';

interface RecapSectionProps {
  icon: React.ElementType;
  title: RenderedContent;
  children: React.ReactNode;
  onEdit?: () => void;
  className?: string;
}

export const RecapSection = ({ 
  icon: Icon, 
  title, 
  children, 
  onEdit, 
  className 
}: RecapSectionProps) => (
  <div className={cn('bg-card rounded-xl border border-gray-border p-4 sm:p-6 w-full', className)}>
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <Icon className="w-5 h-5 text-primary" />
        <h3 className="text-sm font-semibold">{title}</h3>
      </div>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className="text-xs text-primary hover:underline"
        >
          modifier
        </button>
      )}
    </div>
    <div className="space-y-2">{children}</div>
  </div>
);
